import React, { FC, PropsWithChildren, ReactNode } from 'react';
import {
  ButtonProps,
  Icon,
  IconButton,
  Skeleton,
  SkeletonTextLines,
} from '../../../../core-components';
import { twMerge } from 'tailwind-merge';

export const DashboardStageOverviewTitle: FC<{
  title?: ReactNode;
  nextTitle?: ReactNode;
  subTitle?: ReactNode;
  description?: ReactNode;
  buttonItinerary?: ButtonProps;
  fallback?: boolean;
}> = ({
  title,
  nextTitle,
  description,
  subTitle,
  buttonItinerary,
  fallback,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { iconLeft, iconRight, ...preparedButtonItineraryProps } =
    buttonItinerary || {};

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between gap-2">
        {fallback ? (
          <Skeleton className="grow h-6" />
        ) : (
          <>
            <div className="flex flex-col overflow-hidden">
              {!!subTitle && (
                <p className="text-sm text-medium-emphasis">{subTitle}</p>
              )}
              <p className="headline-lg break-words">
                {title}
                {!!nextTitle && (
                  <>
                    <Icon
                      name="arrow-right"
                      size={['xs', { sm: 'sm' }]}
                      className="inline-block align-baseline mx-2"
                    />
                    {nextTitle}
                  </>
                )}
              </p>
            </div>
            {!fallback && !!buttonItinerary && (
              <IconButton
                iconName="map"
                {...preparedButtonItineraryProps}
                className={twMerge(
                  'lg:hidden',
                  preparedButtonItineraryProps.className,
                )}
                variant="secondary"
                on="white"
                children={
                  preparedButtonItineraryProps.asChild &&
                  React.isValidElement(
                    preparedButtonItineraryProps.children,
                  ) ? (
                    React.cloneElement(
                      preparedButtonItineraryProps.children,
                      undefined,
                      null,
                    )
                  ) : (
                    <></>
                  )
                }
              />
            )}
          </>
        )}
      </div>
      {fallback ? (
        <SkeletonTextLines number={2} />
      ) : (
        !!description && <div>{description}</div>
      )}
    </div>
  );
};
